import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ValuationRequestService } from '../../../shared/services/valuations-request.service';
import { MarketService } from '../../../shared/services/market.service';

import { v4 as uuid } from 'uuid';
import { DatePipe } from '@angular/common';

import { Auth } from 'aws-amplify';
import { UpserviceService } from 'src/app/shared/services/upservice.service';
import { ElasticSearchService } from 'src/app/shared/services/elastic-search.service';

@Component({
  selector: 'app-add-valuation-requests',
  templateUrl: './add-valuation-requests.component.html',
  styleUrls: ['./add-valuation-requests.component.css'],
  providers: [UpserviceService,DatePipe],
})
export class AddValuationRequestsComponent implements OnInit {
  isLoading: boolean = false;
  addValuationRequestsForm: FormGroup;
  name: string | undefined;
  propertyId: any;
  properties: any = [];
  isSearchingProperties: boolean = false;
  propertiesResults: boolean = false;
  propertiesSearchResults: any = [];
  propertySearchError: boolean = false;
  selectedProperty: any = {};
  displaySelectedProperty: boolean = false;
  // private fb: FormBuilder
  myDate = new Date();
  date: any;
  display: boolean = false;
  owner: any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private ValuationRequestService: ValuationRequestService,
    private PropertiesService: MarketService,
    private datePipe: DatePipe,
    private upService: UpserviceService,
    private elasticSearchService: ElasticSearchService,
  ) {
    this.getCurrentAuthenticatedUser();
    this.date = this.datePipe.transform(this.myDate, 'yyyy-MM-dd hh:mm:ss');
    console.log(this.date);
    this.addValuationRequestsForm = this.fb.group({
      description: [''],
      propertyName: [''],
      agencyName: [''],
    });
  }

  recievedValuationRequests: any;

  customStylesValidated = false;

  ngOnInit(): void {
    // this.PropertiesService.getProperties('NEW').subscribe(
    //   (data) => {
    //     // this.isLoading = false;
    //     this.properties = data;
    //     console.log('properties', this.properties);
    //   },
    //   (error) => {
    //     // this.isLoading = false;
    //     console.log('Error: ', error);
    //   }
    // );
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  // changePropertyName(e: any) {
  //   this.propertyName?.setValue(e.target.value, {
  //     onlySelf: true,
  //   });
  //   console.log(e.target.value);
  //   for (const x of this.properties) {
  //     if (e.target.value === x.name) {
  //       console.log(x.propertyId);
  //       this.propertyId = x.propertyId;
  //     }
  //   }
  // }

  // Access formcontrols getter
  get propertyName() {
    return this.addValuationRequestsForm.get('propertyName');
  }

  onSelect(id: any) {
    console.log(id.value);
  }

  convertDateToEpoch(dateValue: string) {
    var date = new Date(dateValue);
    return date.getTime();
  }

  onSelectProperty(property: any, propertyId: any) {
    this.propertiesSearchResults = []; //hide the results
    property['propertyId'] = propertyId;
    console.log('selected Property: ', property);
    this.selectedProperty = property;
    this.displaySelectedProperty = true;

    this.addValuationRequestsForm.patchValue({
      propertyName: property.name
    });
  }

  removeProperty() {
    this.selectedProperty = {};
    this.propertiesResults = false;
    this.displaySelectedProperty = false;

    this.addValuationRequestsForm.patchValue({
      propertyName: ''
    });
  }

  onSearchProperties(event: any) {
    if (event.target.value.length > 0) {
      this.isSearchingProperties = true;

      console.log('Keyup: ', event.target.value);

      this.elasticSearchService.searchProperty(event.target.value, this.owner).subscribe(
        (data) => {
          this.isSearchingProperties = false;
          this.propertiesResults = true; //display the results
          this.propertiesSearchResults = data.hits.hits;
          if (data.hits.total.value == 0) {
            this.propertySearchError = true;
          }
          console.log('Elastic Search', data);
          console.log('Search results: ', this.propertiesSearchResults);
        },
        (error) => {
          this.isSearchingProperties = false;
          console.log('Error Searching: ', error);
        }
      );
    } else {
      this.isSearchingProperties = false;
      if (Object.keys(this.selectedProperty).length === 0) {
        this.propertiesResults = false; //hide the results
      }
    }
  }

  onSubmitAddForm() {
    this.customStylesValidated = true;

    if (this.addValuationRequestsForm.valid) {
      setTimeout(() => {
        this.isLoading = true;
        const object = {
          id: 'VAL-REQ-' + uuid(),
          propertyId: this.selectedProperty.propertyId,
          creationDate: this.date,
          description: this.addValuationRequestsForm.value.description,
          propertyName: this.selectedProperty.name,
          status: 'NEW',
          agencyName: this.addValuationRequestsForm.value.agencyName,
          owner: this.owner
        };
  
  
        this.ValuationRequestService.createValuationRequests(object).subscribe(
          (data) => {
            
            console.log(data);
  
            setTimeout(() => {
              // this.router.navigate(['/valuation-requests/view']);
              this.isLoading = false;
              this.router.navigate(['private-space/view-valuation-requests', {}]);
              
            }, 2500);
          },
          (err) => {
            this.isLoading = false;
            console.log(err);
            // this.router.navigate(['/valuation-requests/view']);
          }
        );
        console.log('Form submitted', this.addValuationRequestsForm?.value);
      }, 500);


    } else {
      this.display = true;
    }
  }

  onReset1() {}
}
